import React from 'react';
import { useTranslateFn } from 'utils/useTranslateFn';
import { TranslationKey } from '@danfloss/utils/text-translations';

import classNames from 'classnames';
import styles from './styles.module.scss';

const logoUrl1 = '/@danfloss/Hose Assembly Pro1.svg';
const logoUrlSubtext = '/@danfloss/ByDanfoss.svg';

const logoSmallImages = [
  '/@danfloss/Applications_Tractors.svg',
  '/@danfloss/Applications_Scissor Lift.svg',
  '/@danfloss/Applications_Dump Truck.svg',
  '/@danfloss/Applications_Excavator.svg',
  '/@danfloss/Applications_Forklift.svg',
  '/@danfloss/Applications_Oil Rig.svg',
  '/@danfloss/Applications_Lift Truck.svg',
];

export const DanFlossHeader = () => {
  const t = useTranslateFn<TranslationKey>();

  const img = (t('variables.pdf.logo').startsWith('http') || t('variables.pdf.logo').startsWith('data:'))
    ? t('variables.pdf.logo') : `https://${window.location.host}${t('variables.pdf.logo')}`;

  const shouldShowHeader = t('variables.showHeader') === 'true';

  if (!shouldShowHeader) {
    return null;
  }

  return (
    <section className={classNames(styles.intro)}>
      <div className={classNames(styles.texts)}>
        <div className={classNames(styles.main)}>
          <img src={logoUrl1} alt="Hose AssemblyPro" className={classNames(styles.mainLogo)} />
          <img src={logoUrlSubtext} alt="by Danfoss" className={classNames(styles.subLogo)} />
        </div>
        <img src={img} alt="Brand Logo" className={classNames(styles.customLogo)} />
        <div className={classNames(styles.smallLogos)}>
          {logoSmallImages.map((logo, index) => (
            <img
              key={logo}
              className={classNames(styles.logoSmall)}
              src={logo}
              alt={`Application ${index + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
};
